import { Framework } from "@superfluid-finance/sdk-core";
import { ethers } from "ethers";
import { erc20abi } from "../abis/erc20";
import { SF_CHAIN_NAMES } from "../config/constants";
import { getForwarderAddr, getSuperfluidResolverAddr } from "../config/resolver";
import { getTokenAddress } from "../config/tokens";

function getSfChainName(chainId) {
  return SF_CHAIN_NAMES[chainId];
}

async function getFramework(provider, chainId) {
  const resolverAddr = getSuperfluidResolverAddr(chainId);
  let sf;
  // if (chainId === 31337) {
  //   sf = await Framework.create({
  //     chainId: chainId,
  //     provider: provider,
  //     customSubgraphQueriesEndpoint: "",
  //     resolverAddress: resolverAddr,
  //     // if local network, send test params to create, otherwise don't
  //     dataMode: "WEB3_ONLY",
  //     protocolReleaseVersion: "test",
  //   });
  // } else {
  sf = await Framework.create({
    chainId: chainId,
    provider: provider,
    customSubgraphQueriesEndpoint: "",
    resolverAddress: resolverAddr,
  });
  // }

  return sf;
}

async function getErc20Contract(chainId, signer, erc20Symbol) {
  const erc20Addr = getTokenAddress(chainId, erc20Symbol);

  return new ethers.Contract(erc20Addr, erc20abi, signer);
}

async function getTokenxContract(chainId, signer, tokenxSymbol) {
  const tokenxAddr = getTokenAddress(chainId, tokenxSymbol);
  const tokenxABI = ["function upgrade(uint256 amount) external", "function downgrade(uint256 amount) external"];

  return new ethers.Contract(tokenxAddr, tokenxABI, signer);
}

async function getCFAv1ForwarderContract(chainId, signer) {
  const forwarderAddr = getForwarderAddr(chainId);
  const forwarderABI = [
    "function createFlow(address token, address sender, address receiver, int96 flowrate, bytes memory userData) external returns (bool)",
    "function deleteFlow(address token, address sender, address receiver, bytes memory userData) external returns (bool)",
  ];

  return new ethers.Contract(forwarderAddr, forwarderABI, signer);
}

export { getSfChainName, getFramework, getErc20Contract, getTokenxContract, getCFAv1ForwarderContract };
